import { ErrorHandler, Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { BoardNotFoundError, FatalError, GroupForbiddenError, NotFoundError } from "../models/core/fatal-error.model";

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  public static fatalError: string | undefined;
  public static isFatalError: boolean = false;

  constructor(
    private zone: NgZone,
    private router: Router) {
    super();
  }

  handleError(error: any): void {
    if (error instanceof FatalError || error.rejection instanceof FatalError) {
      this.zone.run(() => {
        this.router.navigate(['error/500']);
      });
    }
    else if (error instanceof BoardNotFoundError || error.rejection instanceof BoardNotFoundError) {
      this.zone.run(() => {
        this.router.navigate(['dashboard/boards/error/404']);
      });
    }
    else if (error instanceof GroupForbiddenError || error.rejection instanceof GroupForbiddenError) {
      this.zone.run(() => {
        this.router.navigate(['error/403']);
      });
    }
    else {
      super.handleError(error);
    }
  }
}
